module.exports = __webpack_public_path__ + "img/2_100.f5bddc75.png";